module.exports = __webpack_public_path__ + "img/208.problem_urinals.03f64b8d.svg";